import cn from 'classnames';

export default function Link({
  href,
  children,
  className,
  ...rest
}) {
  return (
    <a
      href={href}
      className={cn(
        'lds-dropdown-item',
        'lds-dropdown-item-link',
        className
      )}
      {...rest}
    >
      {children}
    </a>
  );
}
